import React, { Component } from 'react';

import classNames from 'classnames';
import Tag from 'components/cosmos/tag';
import { InputGroup } from 'components/input/group';
import { translate } from 'components/translate';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { ContentPageService } from 'modules/content';
import PropTypes from 'prop-types';

import './Tags.scss';

let mergedSuggestions = [];
const TAG_LIMIT = 50;
const ENTER_KEY = 13;
const COMMA_KEY = 44;

@translate()
class Tags extends Component {
  static propTypes = {
    className: PropTypes.string,
    tags: MobxPropTypes.observableArray,
    onTagChange: PropTypes.func,
    t: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
      tag: '',
      cursor: 0
    };
  }

  componentDidMount() {
    this.getSuggestions();
  }

  getSuggestions = async () => {
    const suggestions = await ContentPageService.getTags();

    this.setState({ suggestions });
  };

  mergedSuggestions = () => {
    return this.state.suggestions.filter((suggestion) => {
      return !this.props.tags.some((tag) => {
        return suggestion === tag;
      });
    });
  };

  checkTag = (newTag) => {
    return (
      this.props.tags.filter((tag) => {
        return tag === newTag;
      }).length === 0
    );
  };

  removeTag = (tagId) => {
    const tags = this.props.tags.filter((tag) => tag !== tagId);

    this.props.onTagChange(tags);
  };

  addTag = (tag) => {
    if (this.checkTag(tag)) {
      this.props.onTagChange([...this.props.tags, tag]);
    }

    this.setState({ tag: '', cursor: 0 });
  };

  tagChange = (e) => {
    this.setState({ tag: e.target.value.slice(0, TAG_LIMIT) });
  };

  handleKeyPress = (e, mergedSuggestions) => {
    if ((e.which === COMMA_KEY || e.which === ENTER_KEY) && e.target.value) {
      e.preventDefault();
      if (!this.state.cursor) {
        this.addTag(e.target.value);
      } else {
        this.addTag(mergedSuggestions[this.state.cursor - 1]);
      }
    }
  };

  getBackCursor(e, cursor) {
    const upKey = 38;

    return e.keyCode === upKey && cursor > 0;
  }

  getForwardCursor(e, cursor) {
    const downKey = 40;

    return e.keyCode === downKey && cursor < mergedSuggestions.length;
  }

  handleKeyDown = (e) => {
    const { cursor } = this.state;
    const backCursor = this.getBackCursor(e, cursor);
    const forwardCursor = this.getForwardCursor(e, cursor);

    const tagsList = document.getElementsByClassName('tags__suggestions');
    const listIndex = 0;
    const maxLength = 125;
    const defaultShowItems = 4;
    const moveScroll = this.state.cursor % defaultShowItems === 0;

    if (backCursor) {
      if (moveScroll) {
        tagsList[listIndex].scrollTop -= maxLength;
      }

      this.setState((prevState) => ({
        cursor: prevState.cursor - 1
      }));
    } else if (forwardCursor) {
      if (this.state.cursor && moveScroll) {
        tagsList[listIndex].scrollTop += maxLength;
      }

      this.setState((prevState) => ({
        cursor: prevState.cursor + 1
      }));
    }
  };

  render() {
    const { tag, cursor } = this.state;
    const { className, tags, t } = this.props;

    mergedSuggestions = this.mergedSuggestions().filter(
      (s) => tag === '' || s.toLowerCase().includes(tag.toLowerCase())
    );
    const existTagsAndSuggestions = tag && mergedSuggestions.length;
    const classInput = classNames('tags__input', {
      tags__input__suggestions: existTagsAndSuggestions
    });
    const classComponent = classNames('tags', className);

    return (
      <div className={classComponent}>
        <div className={classInput}>
          <InputGroup
            labelValue="general.tags"
            name="tags"
            value={tag}
            onChange={this.tagChange}
            placeholder="tags.placeholder"
            onKeyPress={(e) => this.handleKeyPress(e, mergedSuggestions)}
            description="tags.description"
            inputClassName="tag__input"
            handleKeyDown={this.handleKeyDown}
            maxLength={TAG_LIMIT}
          >
            {existTagsAndSuggestions ? (
              <div className="tags__suggestions__wrapper">
                <ul className="tags__suggestions">
                  {mergedSuggestions.map((suggestion, index) => {
                    const highlightTag = index + 1 === cursor;

                    const classTagSuggestion = classNames('tag__suggestion', {
                      'tags__suggestions--active': highlightTag
                    });

                    return (
                      <li
                        key={suggestion}
                        className={classTagSuggestion}
                        onClick={() => this.addTag(suggestion)}
                        tabIndex={0}
                      >
                        {suggestion}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              <div />
            )}
          </InputGroup>
        </div>
        <div className="tags__list">
          {tags.map((tag) => (
            <Tag
              key={tag}
              className="_mr-2"
              size="lg"
              dismissButtonLabel={`${t('general.remove')} ${tag}`}
              onDismiss={() => this.removeTag(tag)}
            >
              {tag}
            </Tag>
          ))}
        </div>
      </div>
    );
  }
}

export default Tags;
